import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { AlignCenter, LineClamp } from '../../global/commonStyle';

const TableData = styled.td`
  border-top: 0.5px solid var(--border-primary);
  text-align: start;
  padding: var(--space-12);
  color: var(--text-secondary);
  ${Typography.body_md_medium}
  width: 20%;

  ${mobile_xl(css`
    white-space: nowrap;
    max-width: 52px;
  `)}
  .plus-icon {
    min-width: 16px;
    height: 16px;
  }
  td &:first-child {
    padding: var(--space-12);
    width: 60%;
  }
`;
const ProductName = styled.div`
  color: var(--text-secondary);
  p {
    color: var(--text-secondary);
    ${Typography.body_md_medium}
    margin: var(--space-0);
    ${mobile_xl(css`
      ${LineClamp(2)}
      word-break: break-all;
      white-space: normal;
    `)}
  }
`;

const ProductItem = styled.div`
  ${AlignCenter}
  gap: var(--space-10);
`;

export { ProductName, TableData, ProductItem };
